<div class="flex shadow-md shadow-slate-500 relative w-[95vw] md:w-[600px] lg:w-[640px] xl:w-full">
    <div class="absolute flex flex-col top-1 right-1">
        <ng-container *ngIf="(consulta.estadoId === 3 || consulta.consultaEstadoCita===3); else completeData">
            <div *ngIf="consulta.estadoId === 3 || consulta.consultaEstadoCita=== 3" 
            class="text-pet-color-text-1 text-5xl h-9 hover:text-pet-color-5 h-auto" (click)="confirmPayment()">
                <mat-icon
                matTooltip="Aceptar Cita"
                [matTooltipPosition]="'right'"
                inline="true" class="material-icons-outlined ">check_circle</mat-icon>
            </div>
        </ng-container>
        <ng-template #completeData>
            <div *ngIf="consulta.estadoId === 1 || consulta.consultaEstadoCita === 1 " class="text-pet-color-text-1 text-5xl h-9 hover:text-pet-color-5 h-auto" (click)="confirm()">
                <mat-icon
                matTooltip="Aceptar Cita"
                [matTooltipPosition]="'right'"
                inline="true" class="material-icons-outlined ">check_circle</mat-icon>
            </div>
        </ng-template>
        <div *ngIf="consulta.estadoId !== 4 || consulta.consultaEstadoCita !== 4" 
        class="text-pet-color-text-1 text-5xl h-9 hover:text-pet-color-5 h-auto" (click)="cancel()">
            <mat-icon
            matTooltip="Cancelar Cita"
            [matTooltipPosition]="'right'"
            inline="true" class="material-icons-outlined ">cancel</mat-icon>
        </div>
        <div *ngIf="fechaCita < now && consulta.consultaReagendar"
        (click)="reagendar()"
        class="text-pet-color-text-1 text-5xl h-9 hover:text-pet-color-5 h-auto">
          <mat-icon
          matTooltip="Reprogramar Cita"
          [matTooltipPosition]="'right'"
          inline="true" class="material-icons-outlined ">event_repeat</mat-icon>
        </div>

    </div>
    <div class="flex flex-col items-center justify-center gap-5 py-3 text-white px-10 w-[38%] md:w-[230px] lg:w-[244px] bg-gray-400"
    [ngClass]="{'bg-pet-color-blue-1':consulta.estadoId === 1 || consulta.consultaEstadoCita===1,
                'bg-pet-green-1':consulta.estadoId === 2 || consulta.consultaEstadoCita===2,
                'bg-pet-color-blue-2':consulta.estadoId === 3 || consulta.consultaEstadoCita===3,
                'bg-pet-color-danger-1':consulta.estadoId === 4 || consulta.consultaEstadoCita===4 }">
        <div class="border border-white py-2 px-3 rounded-md text-center">
            {{estadoConsulta[consulta.consultaEstadoCita]}}
            {{estadoConsulta[consulta.estadoId]}}
        </div>
        <div class="text-center">
            {{ consulta.consultaFechaCita| date:'EEEE' }} <br>
            {{ consulta.consultaFechaCita| date:'dd/MM/yy':'medium' }}
        </div>
        <div class="text-2xl text-center font-semibold">
            {{consulta.consultaHoraCita}}
        </div>
    </div>
    <div class="flex flex-col text-sm justify-center  bg-pet-gray-1  py-2 pl-3 pr-3 w-[62%] md:w-[370px] lg:w-[396px]">
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon class="text-lg text-pet-color-6">person</mat-icon>Cliente: {{consulta.nombreUsuario}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon class="text-lg text-pet-color-6">schedule</mat-icon>Tiempo estimado: {{consulta.consultaTiempoEstimadoConsulta}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon class="text-lg text-pet-color-6">list_alt</mat-icon>{{ consulta.atencionNombre}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon class="text-lg text-pet-color-6">attach_money</mat-icon>Valor de la Consulta: $ {{consulta.consultaCostoConsulta | number}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon class="text-lg text-pet-color-6">credit_card</mat-icon>Suscripción: -- --</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon class="text-lg text-pet-color-6">payments</mat-icon>Metodo de Pago: {{consulta.consultaMetodoPago === 1 ? 'Pago en linea' : '-- --'}}</div>
    </div>
</div>

